








































































































































































































































































































































































import { BaseModel } from "@/models/products/base";
import { Component, Watch } from "vue-property-decorator";
import Items from "./Items";
import RadioButtonBox from "@/components/elements/utility/RadioButtonBox.vue";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import { BaseOrderRecord, LineItem, Note } from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import { ConfigFile } from "@/models/configurator/config_file";
import AddToQuoteFooter from "@/components/footer/AddToQuoteFooter.vue";
import ProductService from "@/services/product_service";
import { AuthError, GenericError } from "@/services/error_service";
import FabricSelector from "@/components/items/fabric_picker/FabricSelector.vue";
import MiniSwatch from "@/components/elements/products/MiniSwatch.vue";
import { CustomBaseOrder } from "@/models/configurator/custom_umbrella";
import { ProductLineName } from "@/models/products/collection";
import { UmbrellaType } from "@/models/products/umbrella";
import { Validations } from "vuelidate-property-decorators";
import { required, requiredIf } from "vuelidate/lib/validators";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";
import { NoteFields } from "@/models/order/helpers";
import { FinishHandle } from "@/models/products/finish";
import DropdownFinishes from "@/components/elements/utility/DropdownFinishes.vue";
import Dropdown from "@/components/elements/utility/Dropdown.vue";
import SpecsModal from "@/components/elements/modal/SpecsModal.vue";
import { getFinishImage } from "@/utility/helpers";
import { GlobalActions } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { StoreModule } from "@/store/types";
import { namespace } from "vuex-class";
@Component({
  components: {
    AccordionSection,
    RadioButtonBox,
    AddToQuoteFooter,
    FabricSelector,
    MiniSwatch,
    FormValidation,
    DropdownFinishes,
    Dropdown,
    SpecsModal
  }
})
export default class CustomizeBase extends Items {
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;

  protected spigotValue = "Spigot";
  protected spigotNote = "Intended for Spigot use - No stem requested.";
  protected beautyPlateNote = "Beauty plate included.";
  protected getFinishImage = getFinishImage;
  protected ProductLineName = ProductLineName;
  protected index: null | number = 0;
  protected ProductType = ProductType;
  protected showSpecsModal = false;
  protected item_details: CustomBaseOrder = {
    base: {
      base: null,
      baseFinish: {
        display_name: null as any,
        handle: null as any
      },
      baseStem: null,
      baseOptions: { wheels: false }
    },
    notes: []
  };

  protected productService = new ProductService();
  protected itemPrice = 0;
  protected sku = "";
  protected noteObj = {
    finish: "",
    stem: "",
    options: ""
  };
  protected showNoteModal = {
    finish: false,
    stem: false,
    options: false
  };

  /**
   * Set while a stored line or the defaults are being loaded. Populating the
   * form touches every watched field, so without this each field would issue
   * its own price/SKU request for a config that is still half-built. The
   * loader clears it and asks for one refresh against the finished config.
   */
  private pricingSuspended = false;

  @Watch("item_details.base.base")
  private async onBaseChange(): Promise<void> {
    await this.refreshPricing();
  }

  @Watch("item_details.base.baseFinish.handle")
  private async onFinishChange(): Promise<void> {
    await this.refreshPricing();
  }

  @Watch("item_details.base.baseOptions.wheels")
  private async onWheelChange(): Promise<void> {
    await this.refreshPricing();
  }

  @Watch("item_details.base.baseStem")
  private async onStemChange(): Promise<void> {
    await this.refreshPricing();
  }

  /**
   * Single entry point for repricing. /prices/base 500s when the payload has no
   * `model` — which is the case for any config whose `base` is still an
   * unresolved model code rather than the catalog document — and the resulting
   * "Unable to get price data" toast stays on screen until the user dismisses
   * it. So never issue a request that cannot succeed: an incomplete config is
   * not an error state, it is a not-yet state.
   */
  private async refreshPricing(): Promise<void> {
    const base = this.item_details.base.base;
    if (this.pricingSuspended || !base || !base.model) {
      return;
    }
    await this.updatePrice();
    await this.updateSKU();
  }

  /** ALl custom validations should evaluate to true to submit form. Invalid = false */
  @Validations()
  validations() {
    return {
      item_details: {
        base: {
          base: { required },
          baseFinish: { required },
          baseStem: {
            required: requiredIf(
              () =>
                this.item_details.base.base!.mounts &&
                this.item_details.base.base!.mounts.length > 0
            )
          }
        }
      }
    };
  }

  async created() {
    if (!this.$route.params.edit && this.$route.query.cart) {
      // if a user refreshes or back buttons onto this page, redirect to expired notice. because we are using index to update item, the user must navigate directly from the cart, or we can't guarantee the index is correct
      this.$router.replace("/resubmit");
    } else if (this.$route.params.edit && this.$route.query.cart) {
      this.editMode = true;
      const index = parseInt(this.$route.query.cart as string, 10);
      await this.loadConfig(() => this.prepDataForEdit(index));
    } else {
      await this.loadConfig(() => this.setDefaults());
    }
    this.setNotes();
    this.$emit("ready");
  }

  /**
   * Populate the form without repricing field by field: hold the watchers off
   * for the duration, let the ones they queued drain against the suspended
   * flag, then price the finished config exactly once.
   */
  private async loadConfig(populate: () => Promise<void>): Promise<void> {
    this.pricingSuspended = true;
    try {
      await populate();
      await this.$nextTick();
    } finally {
      this.pricingSuspended = false;
    }
    await this.refreshPricing();
  }

  protected closeSpecsModal(): void {
    this.showSpecsModal = false;
  }

  protected toggleSpecsModal(): void {
    this.showSpecsModal = true;
  }

  /**
   * A base line reaches this page in one of two shapes:
   *   - a draft this app wrote — a CustomBaseOrder, whose configuration is
   *     nested under `base` and already holds full BaseModel / Finish objects;
   *   - a NetSuite-added line rebuilt by the SKU parser — the Node API's
   *     `/products/config` returns a base as the flat `ConfigFile["base"]`
   *     block (`{ base, baseFinish, baseStem, baseOptions }`), so the block
   *     *is* item_details, its `base` is the bare model code ("36G-SQ") and
   *     its `baseFinish` a bare finish handle ("gs").
   * Left as-is the flat form leaves `item_details.base.base` null and the whole
   * page renders empty. Normalize onto the nested shape, then resolve the code
   * references into the catalog objects the template renders from.
   */
  protected async prepDataForEdit(index: number): Promise<void> {
    const stored = (this.storeItems[index].item_details || {}) as any;
    // Peel the configuration keys off whatever else rides on item_details
    // (notes, netsuite_memo) so those survive either shape.
    const { base, baseFinish, baseStem, baseOptions, ...rest } = stored;
    const isFlatConfig = typeof base === "string";
    const storedBase = (isFlatConfig
      ? { base, baseFinish, baseStem, baseOptions }
      : base) || ({} as CustomBaseOrder["base"]);
    // NetSuite SKU-parsed base lines come back without a full base structure
    // (notably no baseOptions). Merge onto the default skeleton so required
    // sub-objects — and baseOptions.wheels the template binds to — always
    // exist, rather than replacing item_details outright.
    const config = {
      ...this.item_details.base,
      ...storedBase,
      baseOptions: {
        wheels: false,
        ...(storedBase.baseOptions || {})
      }
    } as CustomBaseOrder["base"];
    await this.hydrateBaseReferences(config);
    // Assign once, fully resolved. Assigning first and hydrating after would
    // expose the half-built config to the template: `base` is a bare model code
    // at that point, which is truthy enough to pass the root v-if but has no
    // `.attributes`, so the render throws before hydration lands.
    this.item_details = {
      ...this.item_details,
      ...rest,
      base: config
    } as CustomBaseOrder;
    if (this.item_details.notes && this.item_details.notes.length > 0) {
      this.setNotes();
    } else {
      this.item_details.notes = [];
    }
  }

  /**
   * Resolve a SKU-parsed line's code references — model code and finish handle
   * — into the catalog BaseModel and its Finish object. A line saved by this
   * app already carries both, so each step is a no-op for it.
   */
  private async hydrateBaseReferences(
    config: CustomBaseOrder["base"]
  ): Promise<void> {
    if (typeof (config.base as any) === "string") {
      config.base = (await this.getItem(config.base as any)) as BaseModel;
    }
    if (!config.base) return;
    if (config.baseFinish && config.baseFinish.handle) return;
    // A stem sold as a standalone base carries no finish, so the parser leaves
    // baseFinish null; fall back to the model's first finish exactly as
    // setDefaults() does for a fresh line.
    const handle = (config.baseFinish as any) as FinishHandle | null;
    const finishes = config.base.finishes || [];
    config.baseFinish =
      finishes.find(finish => finish.handle === handle) ??
      finishes[0] ??
      ({ handle: null, display_name: null } as any);
  }

  protected mobileSetFinish(handle: FinishHandle): void {
    this.item_details.base.baseFinish!.handle = handle;
  }

  protected setNotes(): void {
    const bf = ["finish", "stem", "model", "options"];
    bf.forEach(field => {
      const obj = this.item_details.notes!.find(e => e.field === field);
      if (obj) {
        let content = obj.content;
        if (field === "stem") {
          content = content.replace(this.spigotNote, "").trim();
          content = content.replace(this.beautyPlateNote, "").trim();
        }
        this.noteObj[field] = content;
      }
    });
  }

  protected addNotesToQuote(): void {
    this.item_details.notes = [];
    for (const [key, value] of Object.entries(this.noteObj)) {
      let content = value;
      if (key === "stem" && this.isSpigotSelected) {
        content = content ? `${this.spigotNote} ${content}` : this.spigotNote;
      }
      if (key === "stem" && this.isBeautyPlateIncluded) {
        content = content
          ? `${this.beautyPlateNote} ${content}`
          : this.beautyPlateNote;
      }
      this.item_details.notes.push({
        field: key as NoteFields,
        content
      });
    }
  }

  get vBaseObject() {
    return this.$v.item_details.base;
  }

  protected async setDefaults(): Promise<void> {
    this.item_details.base.base = (await this.getItem(
      this.handle
    )) as BaseModel;
    this.item_details.base.baseFinish!.handle = this.finishes[0].handle;
  }

  protected async updatePrice(): Promise<void> {
    try {
      const price = await this.productService.getBasePrice({
        model: this.item_details.base.base!.model,
        item_details: {
          ...this.item_details.base,
          base: this.item_details.base.base!,
          baseFinish: this.item_details.base.baseFinish!.handle,
          baseStem: this.isSpigotSelected
            ? null
            : this.item_details.base.baseStem
        }
      });
      this.itemPrice = price.base!;
      // FUMBSD-761: covers a failed GET /prices/surcharge
      if (price.breakdown) this.seedSurcharge(price.breakdown.surcharge);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup(err.message);
    }
  }

  protected async updateSKU(): Promise<void> {
    const data = this.transformDataToConfigFile();
    const sku = await this.productService.createBaseSKU(data);
    this.sku = sku;
  }

  protected get isSpigotSelected(): boolean {
    return this.item_details.base.baseStem === this.spigotValue;
  }

  protected get isBeautyPlateIncluded(): boolean {
    return (
      this.needsSpigotOption &&
      !this.isSpigotSelected &&
      !!this.item_details.base.baseStem
    );
  }

  protected transformDataToConfigFile(): ConfigFile {
    return {
      base: {
        base: this.item_details.base.base?.model ?? null,
        baseFinish: this.item_details.base.baseFinish?.handle ?? null,
        baseStem: this.isSpigotSelected
          ? null
          : this.item_details.base.baseStem ?? null,
        baseOptions: this.item_details.base.baseOptions
      }
    } as ConfigFile;
  }

  protected addToQuote(item: LineItem) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.addNotesToQuote();
      const orderItem = { ...item, item_details: this.item_details };
      orderItem.sku = this.sku;
      this.addItem(orderItem);
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      const baseOptions = { ...orderItem.item_details.base.baseOptions };
      if (orderItem.item_details.base.baseStem) {
        if ((orderItem.item_details.base.baseStem as any) === "Spigot") {
          baseOptions["attachment"] = orderItem.item_details.base.baseStem;
        } else {
          baseOptions["stem"] = orderItem.item_details.base.baseStem;
        }
      }
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        model: orderItem.model,
        name: orderItem.display_name,
        finish: orderItem.item_details.base.baseFinish!.handle,
        options: baseOptions,
        sku: orderItem.sku,
        cost: numberPrice
      });
      this.editMode = true;
    }
  }

  protected editQuote(item: LineItem) {
    const index = parseInt(this.$route.query.cart as string, 10);
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.addNotesToQuote();
      // The footer's lineItem doesn't carry NetSuite line identity
      // (ns_line_id, ns_locked). Merge the edited fields onto the original
      // stored line so a NetSuite-added/linked line keeps its identity and is
      // still recognized as an update — not a brand-new line — on resubmit.
      const original = this.storeItems[index];
      const orderItem = {
        ...original,
        ...item,
        item_details: this.item_details
      };
      orderItem.sku = this.sku;
      this.editLineItem({ item: orderItem, index: index });
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      const baseOptions = { ...orderItem.item_details.base.baseOptions };
      if (orderItem.item_details.base.baseStem) {
        if ((orderItem.item_details.base.baseStem as any) === "Spigot") {
          baseOptions["attachment"] = orderItem.item_details.base.baseStem;
        } else {
          baseOptions["stem"] = orderItem.item_details.base.baseStem;
        }
      }
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        model: orderItem.model,
        name: orderItem.display_name,
        finish: orderItem.item_details.base.baseFinish!.handle,
        options: baseOptions,
        sku: orderItem.sku,
        cost: numberPrice
      });
    }
  }

  protected toggleModal(field: string): void {
    this.showNoteModal[field] = true;
  }

  protected closeModal(): void {
    this.showNoteModal = {
      finish: false,
      stem: false,
      options: false
    };
  }

  /** `attributes` is optional on a catalog base, so never reach through it in
   * the template — an undefined dereference there throws out of the render and
   * takes the whole page with it. */
  get wheelsAvailable(): boolean {
    return !!(this.item_details.base.base?.attributes as any)?.wheels;
  }

  get needsSpigotOption(): boolean {
    const base = this.item_details.base.base;
    if (!base || !base.product_lines) return false;
    return base.product_lines.some(
      pl =>
        pl.umbrella_type === UmbrellaType.Cantilever ||
        pl.display_name === "Nova"
    );
  }

  get stemDropdownData(): { model: string }[] {
    const mounts = this.item_details.base.base?.mounts || [];
    if (this.needsSpigotOption) {
      return [{ model: this.spigotValue }, ...mounts];
    }
    return [...mounts];
  }

  get finishes(): BaseModel["finishes"] {
    // Stems sold as standalone bases have no finishes; sorting undefined would
    // throw out of the render and blank the page.
    return [...(this.item_details.base.base?.finishes ?? [])].sort((a, b) =>
      a.handle > b.handle ? 1 : -1
    );
  }
}
